/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import React, {useEffect} from 'react';
import { notification } from 'antd';
import { connect } from 'react-redux';

const AlertMessage = (props) => {
    // const [messageApi, contextHolder] = message.useMessage();
    const [notificationApi, contextHolderNotification] = notification.useNotification();

    useEffect(() => {
        if (props.showSuccessMsg) {
            notificationApi.open({
                type: 'success',
                message: props.textTitle,
                description: props.textMessage,
            });
            props.onShowSuccessMsg();
        } else if (props.showWarningMsg) {
            notificationApi.open({
                type: 'warning',
                message: props.textTitle,
                description: props.textMessage,
            });
            props.onShowWarningMsg();
        } else if (props.showErrorMsg) {
            notificationApi.open({
                type: 'error',
                message: props.textTitle,
                description: props.textMessage,
            });
            props.onShowErrorMsg();
        } else if (props.showInfoMsg) {
            notificationApi.open({
                type: 'info',
                message: props.textTitle,
                description: props.textMessage,
            });
            props.onShowInfoMsg();
        }
    }, [props, notificationApi]);

    return <div> {contextHolderNotification} </div>;
}

const mapStateToProps = (state) => {
    return {
        showSuccessMsg: state.ConfigurationReducer.showSuccessMsg,
        showWarningMsg: state.ConfigurationReducer.showWarningMsg,
        showErrorMsg: state.ConfigurationReducer.showErrorMsg,
        showInfoMsg: state.ConfigurationReducer.showInfoMsg,
        textMessage: state.ConfigurationReducer.textMessage,
        textTitle: state.ConfigurationReducer.textTitle,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        onShowSuccessMsg: () => {
            dispatch({ type: 'SHOW_SUCCESS_MSG', showSuccessMsg: false, textMessage: null, textTitle: null });
        },
        onShowWarningMsg: () => {
            dispatch({ type: 'SHOW_WARNING_MSG', showWarningMsg: false, textMessage: null, textTitle: null });
        },
        onShowErrorMsg: () => {
            dispatch({ type: 'SHOW_ERROR_MSG', showErrorMsg: false, textMessage: null, textTitle: null });
        },
        onShowInfoMsg: () => {
            dispatch({ type: 'SHOW_INFO_MSG', showInfoMsg: false, textMessage: null, textTitle: null });
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AlertMessage);
